module.exports = __webpack_public_path__ + "img/noticias.86d71042.png";